export const DEEPLINK_SCHEME = 'coolmate://';
